<template>
  <div>
    <h1>{{ this.translate[object] }}</h1>
    <b-form-group
      label-cols="3"
      :label="this.translate[object] + 'No *'"
      :label-for="object + '_no'"
      label-align="left"
      required>
      <b-form-input :id="object+'_no'" v-model="payloads.no" :disabled="!isNew" :state="noValidater"></b-form-input>
      <b-form-invalid-feedback :id="object+'_no'" class="text-left">
        正の整数を入力してください
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      label-cols="3"
      :label="this.translate[object] + '名称 *'"
      :label-for="object + '_name'"
      label-align="left">
      <b-form-input :id="object+'_name'" v-model="payloads.name"></b-form-input>
    </b-form-group>
    <b-form-group
      label-cols="3"
      :label="this.translate[object] + '説明'"
      :label-for="object + '_description'"
      label-align="left">
      <b-form-textarea :id="object+'_description'" rows=5 v-model="payloads.description"></b-form-textarea>
    </b-form-group>
  </div>
</template>
<script>
export default {
  name: 'BasicObject',
  data () {
    return {
      update_info: {}
    }
  },
  props: ['object', 'isNew', 'payloads'],
  computed: {
    noValidater () {
      return Number.isInteger(parseInt(this.payloads.no)) && parseInt(this.payloads.no) > 0
    }
  },
  watch: {
    update_info: {
      handler: function (val, oldVal) {
        if (val !== {}) {
          this.$emit('input', val)
        }
      },
      deep: true
    }
  }
}
</script>
